import React from 'react';
import { motion } from 'framer-motion';
import { tools } from '../data/tools';
export function Hero() {
  return <section className="relative pt-24 pb-0 overflow-hidden bg-blueprint" data-id="element-158">
      <div className="absolute inset-0 bg-scanlines pointer-events-none opacity-50" data-id="element-159" />

      {/* Meta Rail */}
      <div className="hidden lg:flex absolute left-8 top-32 bottom-0 w-8 flex-col items-center font-mono text-[10px] text-ink/40 tracking-widest hairline-r" data-id="element-160">
        <div className="writing-vertical-rl rotate-180 py-8" data-id="element-161">
          LAT 0.00 / LON 0.00 · 2026-06-15 · 11 SYSTEMS TRACKED
        </div>
      </div>

      <div className="max-w-[90rem] mx-auto px-4 sm:px-6 lg:pl-24 lg:pr-8 relative z-10 pt-16 lg:pt-24 pb-20" data-id="element-162">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center" data-id="element-163">
          {/* Left Content */}
          <div className="lg:col-span-7" data-id="element-164">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.6,
            ease: 'easeOut'
          }} data-id="element-165">
              <div className="font-mono text-xs text-lime tracking-widest mb-6 flex items-center gap-4" data-id="element-166">
                <span data-id="element-167">[00]</span>
                <div className="h-px w-12 bg-lime" data-id="element-168" />
                <span data-id="element-169">DPIP · 2026 EDITION</span>
              </div>

              <h1 className="font-display text-6xl md:text-8xl font-bold text-ink leading-[0.9] tracking-tight mb-6 uppercase" data-id="element-170">
                DPIP
              </h1>

              <p className="font-mono text-sm md:text-base text-ink/80 tracking-wide mb-8 max-w-xl leading-relaxed" data-id="element-171">
                2026 Gartner<sup className="text-[0.6em] align-super" data-id="element-172">®</sup>{' '}
                Magic Quadrant<sup className="text-[0.6em] align-super" data-id="element-173">™</sup>{' '}
                for Developer Productivity Insight Platforms
              </p>

              <div className="font-mono text-sm text-ink/70 max-w-xl leading-relaxed mb-12 hairline-l pl-6 border-ink/20" data-id="element-174">
                <p className="mb-4" data-id="element-175">
                  A comprehensive observatory of developer productivity insight
                  platforms. Compare capabilities across DORA, SPACE, and R&D
                  capitalization to find the right fit.
                </p>
                <div className="flex flex-wrap gap-4 text-xs" data-id="element-176">
                  <span className="bg-ink/10 px-2 py-1" data-id="element-177">11 SYSTEMS</span>
                  <span className="bg-ink/10 px-2 py-1" data-id="element-178">30+ SIGNALS</span>
                  <a href="#ai-modules" className="bg-lime/15 text-lime px-2 py-1 border border-lime/40 hover:bg-lime/25 transition-colors" data-id="element-179">
                    AI-NATIVE MODULES →
                  </a>
                </div>
              </div>

              <div className="flex flex-col sm:flex-row items-start gap-6 font-mono text-sm" data-id="element-180">
                <a href="https://waydev.co/demo" target="_blank" rel="noopener noreferrer" className="bg-lime text-base px-8 py-4 font-bold hover:bg-ink transition-colors flex items-center gap-3" data-id="element-181">
                  <span className="w-2 h-2 bg-base rounded-full animate-pulse-fast" data-id="element-182" />
                  INITIATE WAYDEV DEMO
                </a>
                <a href="#compare" className="px-8 py-4 hairline-all hover:bg-ink/5 transition-colors text-ink" data-id="element-183">
                  OPEN SIGNAL BOARD →
                </a>
              </div>
            </motion.div>
          </div>

          {/* Right Visual */}
          <div className="lg:col-span-5 relative h-[400px] flex items-center justify-center" data-id="element-184">
            <div className="absolute inset-0 hairline-all bg-base/50 backdrop-blur-sm p-4 flex flex-col" data-id="element-185">
              <div className="flex justify-between font-mono text-[10px] text-ink/50 mb-4 hairline-b pb-2" data-id="element-186">
                <span data-id="element-187">OSC-01</span>
                <span data-id="element-188">LIVE FEED</span>
              </div>
              <div className="flex-grow relative overflow-hidden flex items-center" data-id="element-189">
                {/* Grid lines */}
                <div className="absolute inset-0 bg-[linear-gradient(rgba(232,232,227,0.05)_1px,transparent_1px),linear-gradient(90deg,rgba(232,232,227,0.05)_1px,transparent_1px)] bg-[size:20px_20px]" data-id="element-190" />

                {/* Animated Waveform */}
                <svg className="w-full h-full absolute inset-0" preserveAspectRatio="none" viewBox="0 0 1000 200" data-id="element-191">
                  <motion.path d="M0,100 L100,100 L120,50 L140,150 L160,100 L300,100 L320,20 L340,180 L360,100 L500,100 L520,70 L540,130 L560,100 L700,100 L720,10 L740,190 L760,100 L900,100 L920,40 L940,160 L960,100 L1000,100" fill="none" stroke="#c4f042" strokeWidth="2" initial={{
                  pathLength: 0,
                  opacity: 0.5
                }} animate={{
                  pathLength: 1,
                  opacity: 1
                }} transition={{
                  duration: 2,
                  ease: 'linear',
                  repeat: Infinity
                }} data-id="element-192" />
                  <motion.path d="M0,100 L100,100 L120,50 L140,150 L160,100 L300,100 L320,20 L340,180 L360,100 L500,100 L520,70 L540,130 L560,100 L700,100 L720,10 L740,190 L760,100 L900,100 L920,40 L940,160 L960,100 L1000,100" fill="none" stroke="#6366f1" strokeWidth="4" className="opacity-30 blur-sm" initial={{
                  pathLength: 0
                }} animate={{
                  pathLength: 1
                }} transition={{
                  duration: 2,
                  ease: 'linear',
                  repeat: Infinity
                }} data-id="element-193" />
                </svg>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Ticker */}
      <div className="w-full hairline-t hairline-b bg-base/80 backdrop-blur-sm overflow-hidden flex whitespace-nowrap py-3 font-mono text-xs tracking-widest text-ink/50" data-id="element-194">
        <div className="ticker-scroll flex items-center" data-id="element-195">
          {[...tools, ...tools, ...tools].map((tool, i) => <div key={i} className="flex items-center" data-id="element-196">
              <span className={`mx-8 ${tool.id === 'waydev' ? 'text-lime font-bold' : ''}`} data-id="element-197">
                {tool.name.toUpperCase()}
              </span>
              <span className="text-ink/20" data-id="element-198">/</span>
            </div>)}
        </div>
      </div>
    </section>;
}